import { render } from "./ListComponent.vue?vue&type=template&id=6dc28c68&scoped=true"
import script from "./ListComponent.vue?vue&type=script&lang=js"
export * from "./ListComponent.vue?vue&type=script&lang=js"

import "./ListComponent.vue?vue&type=style&index=0&id=6dc28c68&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dc28c68"]])

export default __exports__